import shopping from './shopping.json';

// ✅ CORRECCIÓN: Extraer los objetos del JSON
export const GRAMMAR_M3 = [
  ...shopping
];